









import Vue from 'vue';

export default Vue.extend({
  name: 'StudioPlaylistMediaTag',
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
    },
  },
  data() {
    return {
      mediasLength: 0,
    };
  },
  methods: {
    getTagLabels(medias) {
      const labels = [];
      let label = null;

      Object.entries(medias).forEach(item => {
        if (item[1] === 0) return null;
        if (item[0] === 'audio') {
          label = this.$tc('PRODUCTS.LABELS.AUDIO_VARIANT', item[1], {
            cnt: item[1],
          });
          labels.push(label);
        }
        if (item[0] === 'application' || item[0] === 'other') {
          label = this.$tc('PRODUCTS.LABELS.DOCUMENT_VARIANT', item[1], {
            cnt: item[1],
          });
          labels.push(label);
        }
        if (item[0] === 'video') {
          label = this.$tc('PRODUCTS.LABELS.VIDEO_VARIANT', item[1], {
            cnt: item[1],
          });
          labels.push(label);
        }
        if (item[0] === 'photo') {
          label = this.$tc('PRODUCTS.LABELS.PHOTO_VARIANT', item[1], {
            cnt: item[1],
          });
          labels.push(label);
        }
      });
      return labels;
    },
    getTags() {
      const medias = {
        video: 0,
        audio: 0,
        application: 0,
        photo: 0,
      };

      this.playlist.content.forEach(item => {
        if (item.media) {
          if (item.media.file_content === 'audio') {
            medias.audio = medias.audio + 1;
          } else if (
            item.media.file_content === 'application' ||
            item.media.file_content === 'other'
          ) {
            medias.application = medias.application + 1;
          } else if (item.media.file_content === 'video') {
            medias.video = medias.video + 1;
          } else if (item.media.file_content === 'image') {
            medias.photo = medias.photo + 1;
          }
        }
      });

      Object.keys(medias).forEach(key => {
        if (medias[key] === 0) delete medias[key];
      });
      this.mediasLength = Object.keys(medias).length;
      return this.getTagLabels(medias);
    },
  },
});
